module.exports = __webpack_public_path__ + "img/14.540ede92.png";